import { useState, useMemo, useEffect } from 'react';

import 'react-tabs/style/react-tabs.css';

import { Stack, Button, Box, Typography } from '@mui/material';

import formStyles from '../../form/Form.module.css';

/* TABS PANEL */
import SystemTabs from '../../../ui/SystemTabs';
import ItensTabPanel from './tabs/itensTabPanel';
import PessoasTabPanel from './tabs/PessoasTabPanel';
import RegistrosTabPanel from './tabs/RegistrosTabPanel';

/* modules */
import { useHomologationItemModule } from './modules/useHomologationItemModule';
import { useHomologationPessoaModule } from './modules/useHomologationPessoaModule';
import { useHomologationRegistroModule } from './modules/useHomologationRegistroModule';

import { getResumoHomologacao } from './utils/HomologationResumo';

/* hooks */
import { filterTabsByProfile, getInitialTabKey } from '../../../utils/profileTabs';
import { useMRTState } from '../../../hooks/useMRTState';
import { useTabChangeFetch } from '../../../hooks/useTabChangeFetch';

/* campos */
import Input from '../../form/Input';
import TextArea from '../../form/TextArea';
import Checkbox from '../../form/Checkbox';
import Select from '../../form/Select';
import SelectEmpresa from '../../form/SelectEmpresa';

function DadosTabPanel({ dados, handleChange, handleOnBlur, handleOnFocus, optionsEmpresa, optionsSituacao }) {
    return (
        <div>
            <div>
                <Input
                    text="Descrição"
                    title="Descrição da homologação"
                    name="descricao"
                    inputWidth="500px"
                    handleOnChange={handleChange}
                    handleOnFocus={handleOnFocus}
                    handleOnBlur={handleOnBlur}
                    value={dados.descricao || ''}
                />

                <SelectEmpresa
                    text="Empresa"
                    name="empresaId"
                    options={optionsEmpresa || []}
                    handleOnChange={handleChange}
                    handleOnFocus={handleOnFocus}
                    handleOnBlur={handleOnBlur}
                    value={dados.empresaId || ''}
                    isEnum={false}
                    notOptNull={false}
                />

                <Select
                    text="Situação"
                    name="situacaoId"
                    options={optionsSituacao || []}
                    handleOnChange={handleChange}
                    handleOnFocus={handleOnFocus}
                    handleOnBlur={handleOnBlur}
                    value={dados.situacaoId || ''}
                    isEnum={false}
                    notOptNull={false}
                />

                <Checkbox
                    title="Ativa quando marcado"
                    text="Ativo"
                    name="ativo"
                    handleOnChange={handleChange}
                    value={dados.ativo}
                    checked={!!dados.ativo}
                />
            </div>

            <div>
                <TextArea
                    text="Objetivo"
                    type="text"
                    name="objetivo"
                    placeholder="Digite aqui o objetivo da homologação"
                    title="Objetivo"
                    handleOnChange={handleChange}
                    handleOnFocus={handleOnFocus}
                    handleOnBlur={handleOnBlur}
                    value={dados.objetivo || ''}
                    textAlign="left"
                    linhas="8"
                    colunas="120"
                />
            </div>

            <div>
                <Input
                    text="Data"
                    title="Data da homologação"
                    name="data"
                    type="date"
                    inputWidth="180px"
                    handleOnChange={handleChange}
                    handleOnFocus={handleOnFocus}
                    handleOnBlur={handleOnBlur}
                    value={dados.data ? String(dados.data).substring(0, 10) : ''}
                />

                <Input
                    text="Data Início"
                    title="Data de início"
                    name="dataInicio"
                    type="date"
                    inputWidth="180px"
                    handleOnChange={handleChange}
                    handleOnFocus={handleOnFocus}
                    handleOnBlur={handleOnBlur}
                    value={dados.dataInicio ? String(dados.dataInicio).substring(0, 10) : ''}
                />

                <Input
                    text="Data Fim"
                    title="Data de fim"
                    name="dataFim"
                    type="date"
                    inputWidth="180px"
                    handleOnChange={handleChange}
                    handleOnFocus={handleOnFocus}
                    handleOnBlur={handleOnBlur}
                    value={dados.dataFim ? String(dados.dataFim).substring(0, 10) : ''}
                />
            </div>

            <div>
                <Input
                    text="Versão Front"
                    title="Versão inicial do Front"
                    name="versaoFront"
                    inputWidth="220px"
                    handleOnChange={handleChange}
                    handleOnFocus={handleOnFocus}
                    handleOnBlur={handleOnBlur}
                    value={dados.versaoFront || ''}
                />

                <Input
                    text="Versão Back"
                    title="Versão inicial do Back"
                    name="versaoBack"
                    inputWidth="220px"
                    handleOnChange={handleChange}
                    handleOnFocus={handleOnFocus}
                    handleOnBlur={handleOnBlur}
                    value={dados.versaoBack || ''}
                />
            </div>
        </div>
    );
}

function Form({
    dados,
    setDados,
    handleSubmit,
    btnText,
    caminhoVoltar,

    parametro,
    pessoaId,
    empresaId,
    empresaIds,
    empresaTabelaId,
    profile,

    setFlashMessage,
    navigate,

    optionsEmpresa,
    optionsSituacao,
}) {
    const urlParams = new URLSearchParams(window.location.search);

    const params = useMemo(
        () =>
            new URLSearchParams({
                ul: urlParams.get('ul'),
                li: urlParams.get('li'),
                tipo: urlParams.get('tipo'),
                operacao: urlParams.get('operacao'),
                uuid: urlParams.get('uuid'),
                btnText: urlParams.get('btnText'),
            }),
        []
    );

    const submit = (e) => {
        e.preventDefault();
        handleSubmit(dados);
    };

    function handleChange(e) {
        const { name, checked, type, value } = e.target;
        setDados((prev) => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value,
        }));
    }

    function handleOnBlur(e) {}
    function handleOnFocus(e) {}

    const podeExibirTabsFilhas = !!dados?.uuid || !!urlParams.get('uuid');

    const initialTabKey = useMemo(
        () =>
            getInitialTabKey(profile, {
                defaultKey: 'dados',
            }),
        [profile]
    );

    const mrtItens = useMRTState({
        storageKey: 'homologation.itens',
        pageSizeDefault: parametro?.paginacao ?? 5,
    });

    const mrtPessoas = useMRTState({
        storageKey: 'homologation.pessoas',
        pageSizeDefault: parametro?.paginacao ?? 5,
    });

    const mrtRegistros = useMRTState({
        storageKey: 'homologation.registros',
        pageSizeDefault: parametro?.paginacao ?? 5,
    });

    const [activeTabKey, setActiveTabKey] = useState(initialTabKey);

    const pessoaModule = useHomologationPessoaModule({
        dados,
        setFlashMessage,
        parametro,
        pessoaId,
        empresaId,
        empresaIds,
        empresaTabelaId,
        mrt: mrtPessoas,
        isAtive: activeTabKey === 'pessoas',
    });

    const itemModule = useHomologationItemModule({
        dados,
        setFlashMessage,
        empresaTabelaId,
        mrt: mrtItens,
        parametro,
        pessoaId,
        isAtive: activeTabKey === 'itens',
    });

    const registroModule = useHomologationRegistroModule({
        dados,
        setFlashMessage,
        pessoaId,
        empresaTabelaId,
        mrt: mrtRegistros,
        invalidateItemDetail: itemModule.actions.invalidateItemDetail,
        isAtive: activeTabKey === 'registros',
    });

    const resumoHomologacao = useMemo(() => {
        return getResumoHomologacao(itemModule?.state?.rowsResumo || []);
    }, [itemModule?.state?.rowsResumo]);

    useEffect(() => {
        setActiveTabKey(initialTabKey);
    }, [initialTabKey]);

    const tabsConfig = useMemo(() => {
        const base = [
            {
                key: 'dados',
                label: 'Dados',
                title: 'Dados da homologação',
                panel: (
                    <DadosTabPanel
                        dados={dados}
                        handleChange={handleChange}
                        handleOnFocus={handleOnFocus}
                        handleOnBlur={handleOnBlur}
                        optionsEmpresa={optionsEmpresa}
                        optionsSituacao={optionsSituacao}
                    />
                ),
            },
        ];

        if (podeExibirTabsFilhas) {
            base.push(
                {
                    key: 'itens',
                    label: 'Itens',
                    title: 'Itens da homologação',
                    panel: <ItensTabPanel module={itemModule} setFlashMessage={setFlashMessage} />,
                },
                {
                    key: 'pessoas',
                    label: 'Pessoas',
                    title: 'Pessoas da homologação',
                    panel: <PessoasTabPanel module={pessoaModule} setFlashMessage={setFlashMessage} />,
                },
                {
                    key: 'registros',
                    label: 'Registros',
                    title: 'Registros da homologação',
                    panel: <RegistrosTabPanel module={registroModule} empresaTabelaId={empresaTabelaId} />,
                }
            );
        }

        return base;
    }, [
        dados,
        optionsEmpresa,
        optionsSituacao,
        podeExibirTabsFilhas,
        itemModule,
        pessoaModule,
        registroModule,
        setFlashMessage,
        empresaTabelaId,
    ]);

    const tabsConfigFinal = useMemo(() => filterTabsByProfile(tabsConfig, profile, parametro), [tabsConfig, profile, parametro]);

    const { onTabChange } = useTabChangeFetch({
        initialKey: initialTabKey,
        onChange: async (key) => {
            setActiveTabKey(key);

            const refreshActions = {
                itens: () => itemModule.actions?.onEnterTab?.(),
                pessoas: () => pessoaModule.actions?.onEnterTab?.(),
                registros: () => registroModule.actions?.onEnterTab?.(),
            };

            if (refreshActions[key]) await refreshActions[key]();
        },
    });

    return (
        <form onSubmit={submit}>
            <h1>{profile?.labelForm || 'Homologação do Sistema'}</h1>

            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1.5, mb: 2 }}>
                <Box sx={{ p: 1.5, border: '1px solid', borderColor: 'divider', borderRadius: 1.5, minWidth: 140 }}>
                    <Typography variant="caption" sx={{ fontWeight: 'bold', display: 'block' }}>
                        Total de Itens
                    </Typography>
                    <Typography variant="h6">{resumoHomologacao.total}</Typography>
                </Box>

                <Box sx={{ p: 1.5, border: '1px solid', borderColor: 'divider', borderRadius: 1.5, minWidth: 140 }}>
                    <Typography variant="caption" sx={{ fontWeight: 'bold', display: 'block' }}>
                        Homologados
                    </Typography>
                    <Typography variant="h6">{resumoHomologacao.homologados}</Typography>
                </Box>

                <Box sx={{ p: 1.5, border: '1px solid', borderColor: 'divider', borderRadius: 1.5, minWidth: 140 }}>
                    <Typography variant="caption" sx={{ fontWeight: 'bold', display: 'block' }}>
                        Em Prazo
                    </Typography>
                    <Typography variant="h6">{resumoHomologacao.emPrazo}</Typography>
                </Box>

                <Box sx={{ p: 1.5, border: '1px solid', borderColor: 'divider', borderRadius: 1.5, minWidth: 140 }}>
                    <Typography variant="caption" sx={{ fontWeight: 'bold', display: 'block' }}>
                        Atrasados
                    </Typography>
                    <Typography variant="h6">{resumoHomologacao.atrasados}</Typography>
                </Box>

                <Box sx={{ p: 1.5, border: '1px solid', borderColor: 'divider', borderRadius: 1.5, minWidth: 160 }}>
                    <Typography variant="caption" sx={{ fontWeight: 'bold', display: 'block' }}>
                        Progresso Geral
                    </Typography>
                    <Typography variant="h6">{resumoHomologacao.progresso}%</Typography>
                </Box>
            </Box>

            <SystemTabs tabs={tabsConfigFinal} onTabChange={onTabChange} initialKey={initialTabKey} />

            {!podeExibirTabsFilhas && (
                <Box sx={{ paddingLeft: 2, paddingRight: 2, paddingBottom: 1 }}>
                    <Typography variant="body2">
                        Salve primeiro a homologação para liberar as abas de Itens, Pessoas e Registros.
                    </Typography>
                </Box>
            )}

            <div className={formStyles.stiloPadrao}>
                <div>
                    <Stack direction="row" spacing={1}>
                        <Button variant="contained" color="secondary" onClick={() => navigate(caminhoVoltar, params)}>
                            Voltar
                        </Button>
                        <Button type="submit" variant="contained" color="success">
                            {btnText}
                        </Button>
                    </Stack>
                </div>
            </div>
        </form>
    );
}

export default Form;
